module.exports = __webpack_public_path__ + "img/option_one.51681c82.png";